const setCssVariable = () => {
	const header = document.getElementById("site-header");
	if (!header) return;

	const headerHeight = header.getBoundingClientRect().height;
	document.documentElement.style.setProperty(
		"--header-height",
		`${headerHeight}px`,
	);

	const panels = document.querySelectorAll(
		'[role="tabpanel"]',
	) as NodeListOf<HTMLElement>;
	if (!panels) return;

	const measure = (element: HTMLElement): number => {
		return Math.ceil(
			Math.max(element.scrollHeight, element.getBoundingClientRect().height),
		);
	};

	let maxH = 0;
	for (const p of panels) {
		const h = measure(p);
		if (h > maxH) maxH = h;
	}
	document.documentElement.style.setProperty("--panel-height", `${maxH}px`);
};

const debounce = <Args extends unknown[]>(
	callback: (...args: Args) => void,
	delay = 250,
) => {
	let timeoutId: ReturnType<typeof setTimeout> | null = null;
	return (...args: Args) => {
		if (timeoutId !== null) clearTimeout(timeoutId);
		timeoutId = setTimeout(() => callback(...args), delay);
	};
};

// 初回設定
window.addEventListener("DOMContentLoaded", setCssVariable);
// レイアウトシフト対策
window.addEventListener("load", setCssVariable);

// リサイズ時
const onResize = debounce(setCssVariable, 250);
window.addEventListener("resize", onResize);

export default setCssVariable;
